import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import "./styles/index.css";
import Landing from "./Pages/Landing"
import Signup from "./Pages/Signup"
import Home from "./Pages/Home";
import './styles/App.css'
import NoPage from "./Pages/NoPage"

import Signin from "./Pages/Signin";

export default function App() {
  return (
 <Router>
      <div>
        <Routes>
          <Route exact path='/' element={<Landing />} />
          <Route exact path='/landing' element={<Landing />} />
          <Route exact path='/signin' element={<Signin />} />
          <Route exact path='/signup' element={<Signup />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </div>
    </Router>
  );

}
